import React, { Component } from "react";
import { Toaster } from "react-hot-toast";
import "./css/main.css";
import Routes from "./routes/Routes";

export default (class App extends Component {
  render() {
    return (
      <>
        <Toaster
          position="bottom-right"
          toastOptions={{
            duration: 5000,
            style: {
              padding: "10px 20px",
              borderRadius: "5px",
              fontSize: "14px",
              lineHeight: "1.3",
              boxShadow: "0 20px 15px -15px rgba(134, 134, 134, 0.18)",
            },
            success: {
              style: {
                background: "#17a95bde",
                color: "white",
              },
            },
            error: {
              style: {
                background: "#DC2626",
                color: "white",
              },
            },
          }}
        />
        <Routes />
      </>
    );
  }
});
